export const mealPlanChooseAthletesFormToSaveTooltips = (selectedAthleteIds: string[]) => {
  let tooltips: string[] = [];
  if (selectedAthleteIds.length === 0) {
    tooltips.push("Select at least one athlete to copy to");
  }
  return tooltips;
};
